import { SearchDirection } from '@lmt/shared-types';
import { TimeSlotSearchOptions } from '@lmt/unicorn-shared/app/components/calendar/visit/components/TimeSlotSearchOptions';
import {
  Button,
  ButtonColor,
  ButtonWidth,
} from '@lmt/unicorn-shared/app/components/common/ui-kit/buttons/Button';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import React, { useState } from 'react';

import ArrowLeftIcon from '@lmt/unicorn-shared/app/icons/arrow-left-grey.svg?react';
import ArrowRightIcon from '@lmt/unicorn-shared/app/icons/arrow-right-grey.svg?react';
import DoubleArrowLeftIcon from '@lmt/unicorn-shared/app/icons/double-arrow-left-grey.svg?react';
import DoubleArrowRightIcon from '@lmt/unicorn-shared/app/icons/double-arrow-right-grey.svg?react';

import styles from './FreeTimeSlotSearchControl.module.scss';

interface Props {
  isSearchAvailable?: boolean;
  onSearch: (
    searchDirection: SearchDirection,
    skipCurrentDay: boolean,
    isParticularTime: boolean,
  ) => void;
  timeStepInMinutes: number;
}

const FreeTimeSlotSearchControl: React.FC<Props> = React.memo(
  function FreeTimeSlotSearch(props) {
    const i18n = useScopedTranslation('event.visit');
    const [isParticularTime, setIsParticularTime] = useState(false);

    return (
      <div className={styles.container}>
        <div>
          <span className={styles.title}>
            {i18n.t('search_free_slot_label')}
          </span>
        </div>
        <Button
          className={styles.arrowButton}
          iconComponent={<ArrowLeftIcon />}
          color={ButtonColor.Primary}
          width={ButtonWidth.Fullwidth}
          onClick={() => props.onSearch(SearchDirection.Backward, false, false)}
          disabled={!props.isSearchAvailable}
          testId="FreeTimeSlotSearch-ArrowLeft"
        />
        <div>
          <span
            className={
              props.isSearchAvailable ? styles.label : styles.labelDisabled
            }
            data-test-id="FreeTimeSlotSearch-TimeStep"
          >
            {i18n.t('search_free_slot_within_day', {
              count: props.timeStepInMinutes,
            })}
          </span>
        </div>
        <Button
          className={styles.arrowButton}
          iconComponent={<ArrowRightIcon />}
          color={ButtonColor.Primary}
          width={ButtonWidth.Fullwidth}
          onClick={() => props.onSearch(SearchDirection.Forward, false, false)}
          disabled={!props.isSearchAvailable}
          testId="FreeTimeSlotSearch-ArrowRight"
        />
        <Button
          iconComponent={<DoubleArrowLeftIcon />}
          className={styles.arrowButton}
          color={ButtonColor.Primary}
          width={ButtonWidth.Fullwidth}
          onClick={() =>
            props.onSearch(SearchDirection.Backward, true, isParticularTime)
          }
          disabled={!props.isSearchAvailable}
          testId="FreeTimeSlotSearch-DoubleArrowLeft"
        />
        <div>
          <span
            className={
              props.isSearchAvailable ? styles.label : styles.labelDisabled
            }
          >
            {i18n.t('search_free_slot_skip_day')}
          </span>
        </div>
        <Button
          iconComponent={<DoubleArrowRightIcon />}
          className={styles.arrowButton}
          color={ButtonColor.Primary}
          width={ButtonWidth.Fullwidth}
          onClick={() =>
            props.onSearch(SearchDirection.Forward, true, isParticularTime)
          }
          disabled={!props.isSearchAvailable}
          testId="FreeTimeSlotSearch-DoubleArrowRight"
        />
        <TimeSlotSearchOptions
          isParticularTime={isParticularTime}
          setIsParticularTime={setIsParticularTime}
        />
      </div>
    );
  },
);

export default FreeTimeSlotSearchControl;
